import React, { useEffect } from 'react';

/**
 * AdInterstitial — DISABLED to comply with Google AdSense policy
 * ("Ads on pages or screens without publisher content").
 *
 * A full-screen interstitial that only contains an ad and a close button has
 * no publisher content. Google flags these and they put the AdSense account
 * at risk. We keep the component import-compatible but render nothing.
 */
const AdInterstitial = ({ show, onClose }) => {
  useEffect(() => {
    if (show && typeof onClose === 'function') onClose();
  }, [show, onClose]);
  return null;
};

export default AdInterstitial;
